// extracted by mini-css-extract-plugin
export default {"addMoneyInput":"W7dqZl","addMoneyCta":"GnX8UL"};